import { render } from "./displayScreenDemo.vue?vue&type=template&id=75db4ef2&scoped=true"
import script from "./displayScreenDemo.vue?vue&type=script&lang=js"
export * from "./displayScreenDemo.vue?vue&type=script&lang=js"

import "./displayScreenDemo.vue?vue&type=style&index=0&id=75db4ef2&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75db4ef2"]])

export default __exports__